selectCallback = function(variant) {
  if (variant && variant.available) {
    $('#BIS_trigger').hide(); // hide the button
  } else {
    setTimeout(() => {
      $('#BIS_trigger').show().attr('data-variant-id', variant.id); // show the button and set the default variant
    }, "500");
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const addToCartButton = document.getElementsByClassName('add-to-cart-once');

  for (const button of addToCartButton) {
    const textElement = button.querySelector('[data-button-text]');
    const form = button.closest('form[data-type="add-to-cart-form"]');

    let added = false;

    form.addEventListener('submit', function() {
      button.disabled = true;           // Disable the button
      textElement.innerText = 'Gift Option Added';   // Update button text to indicate action
      added = true;
    });

    button.addEventListener('click', function(e) {
      if (added) {
        e.preventDefault();
        return;
      }
    });
  }
});
